import { Info, Oauth2Service, obiektService, RodzPokoiInfo, roomsService, webRoom, Result } from 'api';
import { daysFromDate, sendErrorLog, themeExist, themeSelect, selectTheme } from 'app/common/helpers';
import { Actions, AppState, store, ZapisanyFormularz, IPageState } from 'appredux';



  export const getHashToken = () : string => {
    const fragmentString = window.location.hash.substring(1)
    const regex = /([^&=]+)=([^&]*)/g
    let result: RegExpExecArray | null

    result = regex.exec(fragmentString)

    if (result !== null)
      return result[2]
    else
      return ''
  }

  
  export const getDataFromSessionStorage = async () => {
    try {
      const zapisanyFormularz = sessionStorage.getItem("zapisanyFormularz")

      if (zapisanyFormularz) {
        const accessToken = getHashToken()
        if (accessToken) {
          const parsedFormularz: ZapisanyFormularz = JSON.parse(zapisanyFormularz)

          if (parsedFormularz.dostawca === 'Google') {
            const res = await Oauth2Service.userinfo({ access_token: accessToken })

            await store.dispatch(Actions.pageState.setZapisanyFormularzAndInitialValues(
              parsedFormularz,
              {
                email: res.email,
                name: res.given_name,
                phone: '',
                remarks: '',
                surname: res.family_name
              },
              res.picture
            ))
          }
          else if (parsedFormularz.dostawca === 'Facebook') {
            const res = await Oauth2Service.me({ access_token: accessToken })

            await store.dispatch(Actions.pageState.setZapisanyFormularzAndInitialValues(
              parsedFormularz,
              {
                email: res.email,
                name: res.first_name,
                phone: '',
                remarks: '',
                surname: res.last_name
              },
              res.picture.data.url
            ))
          }
        }
        else
          sessionStorage.removeItem("zapisanyFormularz")
      }
    } catch (error) {
      await sendErrorLog("0", "-1", 'pobieranie danych od dostawcy')
      await store.dispatch(Actions.pageState.addFcmLogMessage("pobieranie danych od dostawcy", 2))
      console.error(error)
    }
  }
